import { render, staticRenderFns } from "./BusinessMedications.vue?vue&type=template&id=f999f894"
import script from "./BusinessMedications.vue?vue&type=script&lang=js"
export * from "./BusinessMedications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports